<mat-toolbar class="of-header" color="white">
  <mat-toolbar-row class="header__toolbar-row" *ngIf="headerState | async as data" >

    <!-- LEFT HAND ACTIONS -->
    <div class="header__column header__actions header__actions--left-hand">

      <!-- Left Aligned Button Projection -->
      <ng-content class="header__menu-button" select="button.left"></ng-content>

      <!-- Practice Selection  -->
      <ofi-foundation-practice-select
        class="header__practice-select"
        [displayPractice]="data.visibility?.selectPractice"
        [displayOrganization]="data.visibility?.selectOrganization"
        [practices]="(data.practices.length > 0) ? data.practices : data?.user?.Practices"
        [organizations]="data.organizations"
        [selectedPractice]="data.practice"
        [selectedOrganization]="data.organization || {Name: data?.user?.OrganizationName, OrganizationId: data?.user?.OrganizationId}"
        [loadingPractices]="data.loading.practices"
        [loadingOrganizations]="data.loading.organizations"
        adaptive="true"
        (practiceSelectionChange)="onSelectPractice($event)"
        (organizationSelectionChange)="onSelectOrganization($event)"
      ></ofi-foundation-practice-select>

    </div>


    <!-- CENTER IMAGE CONTAINER -->
    <div class="header__column header__title">

      <!-- Practice (Location) Logo -->
      <img
        *ngIf="data.visibility?.whiteLabelLogo === true;else orthofi_logo"
        #logo
        class="header__logo header__practice-logo"
        [ngClass]="(data.practice?.LogoUrl)?'is-visible':'is-hidden'"
        id="practice-logo"
        [src]="practice?.LogoUrl"
        [alt]="data.practice?.Name + ' Logo'"
      />

      <!-- OrthoFi Logo -->
      <ng-template #orthofi_logo>
        <img
          #logo
          *ngIf="data.visibility?.logo === true && data.visibility?.whiteLabelLogo === false"
          class="header__logo header__orthofi-logo"
          src="https://cdn.orthofi.com/img/logos/logo-2019-blue.svg"
          alt="OrthoFi Logo"
        />
      </ng-template>

    </div>


    <!-- RIGHT-HAND ACTIONS -->
    <div class="header__column header__actions header__actions--right-hand">

      <!-- Right Aligned Button Projection -->
      <ng-content class="header__menu-button" select="button.right"></ng-content>

      <!-- Locale Select -->
      <ofi-foundation-locale-select
        *ngIf="data.visibility?.locale"
        [locale]="data?.locale"
        [locales]="data.locales"
        (localeSelectionChanged)="onSelectLocale($event)"
        data-qa="headerLocalSelect"
      ></ofi-foundation-locale-select>

      <!-- Google Translate wrapper -->
      <div class="header__translate" ngClass="header__translate--is-fullsize" *ngIf="data.visibility?.translate">
        <span id="google_translate_element"></span>
      </div>

      <!-- User Name and Menu -->
      <ng-container *ngIf="data.visibility?.user && (data.user || data.username)">
        <button
          mat-icon-button
          [matMenuTriggerFor]="userMenu"
          class="locale__button"
          class="header__user"
          [matMenuTriggerFor]="userMenu"
          [ngClass]="{'header__user--is-empty': data?.userMenuItems?.length < 1 }"
          data-qa="headerUserMenuButton"
        >
          <p class="header__username" data-qa="headerUsername">{{ data?.username || data?.user.Name.substr(0, data?.user.Name.indexOf(' ')) }}</p>
          <mat-icon class="header__usericon" alt="Account Icon">account_circle</mat-icon>
        </button>
      </ng-container>
    </div>

  </mat-toolbar-row>
</mat-toolbar>

<!-- Account Menu -->
<mat-menu #userMenu="matMenu" class="header__menu" data-qa="headerUserMenu">
  <ng-container *ngIf="headerState | async as data">
    <ng-container *ngFor="let item of data.userMenuItems">
      <a mat-menu-item class="header__menu-button button-link-normal" [attr.href]="item.url" data-qa="headerUserMenuOption">{{item.name}}</a>
    </ng-container>
  </ng-container>
</mat-menu>
